import React from 'react';

export const renderBooleanCell = (value: boolean | null | undefined): React.ReactNode => {
  if (value !== null && value !== undefined) {
    return (
      <span className={value ? 'text-green-600 font-medium' : 'theme-text-tertiary'}>
        {value ? 'Yes' : 'No'}
      </span>
    );
  }
  return <span className="theme-text-tertiary">-</span>;
};

export const renderWorkRequestBadges = (workRequest: string[] | null | undefined): React.ReactNode => {
  if (workRequest && workRequest.length > 0) {
    return (
      <div className="flex flex-wrap gap-1">
        {workRequest.map((wr, idx) => (
          <span key={idx} className="inline-block px-1.5 py-0.5 bg-blue-100 text-blue-800 rounded text-sm">
            {wr}
          </span>
        ))}
      </div>
    );
  }
  return <span className="theme-text-tertiary">-</span>;
};
